import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type GameNewsList = paths['/v4/game/{slug}/news/'];

const getGameNewsList = createRequest<GameNewsList>('/pc/v4/game/{slug}/news/');

export default getGameNewsList;
